import { ReactComponent as LogoIcon } from "assets/icon/icon.svg";
import { ReactComponent as InvertedLogoIcon } from "assets/icon/icon-inverted.svg";
import { Box, useTheme } from "@mui/material";

const Logo = ({ maxHeight = "2.5rem", maxWidth = "2.5rem" }: { maxHeight?: string; maxWidth?: string }) => {
	const theme = useTheme();

	return (
		<Box
			maxWidth={maxWidth}
			maxHeight={maxHeight}>
			{theme.palette.mode === "dark" ? (
				<LogoIcon
					width={"100%"}
					height={"100%"}
				/>
			) : (
				<InvertedLogoIcon
					fill="rgba(0, 0, 0, 0.54)"
					width={"100%"}
					height={"100%"}
				/>
			)}
		</Box>
	);
};

export default Logo;
